
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.277.04l7.206 2.478c.32.106.534.4.534.72 0 .106.4 9.378-7.633 12.682-.08.027-.134.053-.214.08h-.16a.754.754 0 01-.4-.107C-.397 12.563.003 3.317.003 3.237a.848.848 0 01.534-.72L7.743.04a.91.91 0 01.534 0zM8.01 1.639L1.605 3.85c.026 1.839.613 7.94 6.405 10.498 5.791-2.558 6.379-8.633 6.405-10.498L8.01 1.64zm4.367 6.718c-.312 1.068-1.622 3.436-4.367 4.368V8.357h4.367zM8.01 2.898v4.368H4.189c-.182-.486-.546-1.69-.546-2.62L8.01 2.897z"}})])
          )
        }
      }
    